export default __webpack_public_path__ + "static/Calibre-Light-bed6f4c0009a517bd305c0f948ec5998.woff";